<template>
<nav class="navbar navbar-expand-sm bg-light navbar-light">

  <div class="container-fluid">
    <ul class="navbar-nav">
      <li class="nav-item">
          <router-link to="/features" class="nav-link" exact>
            Feature Request
        </router-link>
      </li>
      <li class="nav-item">
        <router-link to="/users" class="nav-link" exact>
            Users
        </router-link>
      </li>
    </ul>
    <ul class="navbar-nav navbar-right">
      <li class="nav-item">
          <span class="desNav">
            <i class="fa-solid fa-user"></i>
              {{authUserName }}
          </span>
          <span class="logout" @click="logoutUser">
            <i class="fa-solid fa-sign-out"></i>
              Logout
          </span>
      </li>
    </ul>
  </div>

</nav>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      name: 'NavBar',
      authId: '',
      authUserName: '',
    }
  },

  async created() {
    await this.fetchUSer()
  },
  methods: {
    async fetchUSer() {
      await axios
      .get(this.$apiUrl + 'users/' + localStorage.getItem('authId'))
      .then(response => {
        this.authUserName = response.data.firstname;
      })
      .catch(error => {
        console.log(error)
      })
    },
    logoutUser() {
      window.localStorage.clear();
      this.$router.push('/login');
      window.location.reload()
    }
  },
}
</script>

<style scoped>
.navbar-light .navbar-nav .nav-link {
    color: rgb(0 0 0 / 77%);
    cursor: pointer;
}
.navbar-light .navbar-nav .nav-link:hover {
  color: black;
}
.router-link-exact-active{
  background :#adb5bd63;
}
.desNav {
  margin-right: 15px;
  color: rgb(0 0 0 / 77%);
}
.logout {
  color: rgb(0 0 0 / 77%);
  cursor: pointer;
}
.logout:hover {
  color: black;
}
</style>